import {
    Component,
    OnInit,
    Input,
    Output,
    ViewEncapsulation,
    EventEmitter,
    SimpleChanges
} from '@angular/core';
import { AuthenticationService } from "../../core/services/authentication.service";
import { WishListService } from "../../core/services/wish-list.service";
import { Router } from "@angular/router";
import {CartService} from "../../core/services/cart.service";
import {UserService} from "../../core/services/user.service";
import {NetworkService} from "../../core/services/network.service";

@Component({
    selector: 'package',
    templateUrl: '../package/package.component.html',
    styleUrls: ['../package/package.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PackageComponent implements OnInit {
    @Input() packageInfo: any;
    @Output() updateInfo = new EventEmitter<any>();
    currentIndex: number;
    currentItem = {
        name: '',
        url: ''
    };
    api;
    videoSrc: string;

    constructor(private authenticationService: AuthenticationService,
                private networkService: NetworkService,
                private wishList: WishListService,
                private cartService: CartService,
                private userService: UserService,
                private router: Router) {}

    ngOnInit() {
        if (this.packageInfo.videos) {
            if (typeof this.packageInfo.videos === 'object') {
                this.currentItem = this.packageInfo.videos;
                this.videoSrc = this.packageInfo.videos.url;
            } else if (this.packageInfo.videos.length) {
                this.currentIndex = 0;
                this.currentItem = this.packageInfo.videos[this.currentIndex];
                this.videoSrc = this.packageInfo.videos.url;
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.packageInfo.firstChange && changes.packageInfo.currentValue.videos && changes.packageInfo.previousValue.videos) {
            if (changes.packageInfo.currentValue.videos.url !== changes.packageInfo.previousValue.videos.url) {
                this.updateVideoSrc(changes.packageInfo.currentValue);
            }
        }
    }

    updateVideoSrc(packageInfo) {
        this.videoSrc = packageInfo.videos.url;
        this.api.getDefaultMedia().elem.src = this.videoSrc;
    }

    isProductInTheWishList() {
        if(this.authenticationService.isAuthenticated()) {
            return this.wishList.isProductInTheWishList(this.packageInfo.id);
        }
    }

    addProductToWishList() {
        if (this.isAuthenticatedUser()) {
            this.wishList.addToWishList(this.packageInfo);
        }
    }

    removeProductFromWishList() {
        this.wishList.removeFromWishList(this.packageInfo);
    }

    isProductInTheCart() {
        if(this.authenticationService.isAuthenticated()) {
            return this.cartService.isProductInTheCart(this.packageInfo.id);
        }
    }

    isProductPurchased() {
        if(this.authenticationService.isAuthenticated()) {
            return this.userService.isProductPurchased(this.packageInfo.id);
        }
    }

    addProductToCart() {
        if (this.isAuthenticatedUser()) {
            this.cartService.addProductToCart(this.packageInfo);
        }
    }

    removeProductFromCart() {
        this.cartService.removeProductFromCart(this.packageInfo);
    }

    onPlayerReady(api) {
        this.api = api;
        this.api.getDefaultMedia().subscriptions.ended.subscribe(() => {
            this.api.play();
        });
    }

    onClickPlaylistItem(index) {
        this.api.play();
        this.currentIndex = index;
        this.setPlayingVideo();
    }

    setPlayingVideo() {
        this.currentItem = this.packageInfo.videos[this.currentIndex];
        this.api.getDefaultMedia().currentTime = 0;
        this.api.play();
    }

    openProduct(product) {
        if (product.link) {
            this.updateInfo.emit(product.link)
        }
    }

    isAuthenticatedUser() {
        if(!this.authenticationService.isAuthenticated()) {
            this.router.navigate([{ outlets: { popup: 'login' }}]);
        }
        return this.authenticationService.isAuthenticated();
    }

    hasVideos(packageInfo) {
        return packageInfo.videos && Object.keys(packageInfo.videos).length;
    }

    updateProduct(link) {
        this.networkService.getProduct(link)
            .then(response => {
                window.scrollTo(0, 0);

                this.packageInfo = response.data[0];
                if (response.links) {
                    this.packageInfo['links'] = response.links;
                }

                this.updateVideoSrc(this.packageInfo);
            });
    }

    reloadPage() {
        window.scrollTo(0, 0);
        window.location.reload();
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/package/package.component.ts